import styled from 'styled-components';
export const LayoutHeaderWrap = styled.div`
    .ant-page-header.osui-page-header {
        font-family: var(--font-family-PingFangScMedium);
        font-size: var(--font-size-large);
        color: var(--color-gray-9);
        padding: 12px 16px !important;
        min-height: auto;

        .ant-page-header-heading-title {
            height: 24px !important;
            line-height: 24px !important;
            font-size: 16px !important;
        }
    }
`;
